import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import './public/styles/global.css'; // Import the global CSS file
import NiceModal from '@ebay/nice-modal-react';
 
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <NiceModal.Provider> 
        <App />
 
        </NiceModal.Provider>
   
  </React.StrictMode>
);
reportWebVitals();